import React from "react";

const PrintStyles = () => (
  <style>{`
    @media print {
      @page { margin: 0; size: auto; }
      
      html, body, #root {
        height: 1px !important;
        min-height: 1px !important;
        overflow: visible !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      /* Скрываем границы и фон у инпутов */
      .no-print-border {
        border: none !important;
        background: transparent !important;
        padding: 0 !important;
        border-bottom: none !important; /* Убираем нижнюю черту при печати */
      }
      
      /* Полностью скрываем placeholder (надпись "Примечание...") */
      input::placeholder {
          color: transparent !important;
          opacity: 0 !important;
          visibility: hidden !important;
      }
      
      body * { 
        visibility: hidden; 
        height: 0 !important; 
      }
      
      #print-area, #print-area * { 
        visibility: visible; 
        height: auto !important; 
      }
      
      #print-area { 
        position: absolute; 
        left: 0; 
        right: 0;
        top: 0; 
        width: 100%; 
        margin: 0;
        padding: 15mm; 
        box-sizing: border-box; 
        background-color: white !important; 
        color: black !important; 
        font-family: "Segoe UI", Arial, sans-serif !important;
        font-size: 12px;
        display: block !important;
      }
      
      .no-print { display: none !important; }
      .only-print { display: block !important; }
      
      * { 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact; 
        background-color: transparent !important;
        color: black !important; 
        border-color: #cbd5e1 !important;
        box-shadow: none !important;
      }
      
      /* === ЗАГОЛОВОК КАТЕГОРИИ === */
      .cat-header-print {
         background-color: #f1f5f9 !important;
         color: #3b82f6 !important;
         border-bottom: 2px solid #000 !important; 
         padding: 2px 5px !important; 
         margin-top: 5px !important;
         text-align: left !important;
         font-size: 12px !important;
         -webkit-print-color-adjust: exact;
         height: auto !important;
         
         /* 🔥 ГЛАВНОЕ ИСПРАВЛЕНИЕ: ЗАПРЕТ ПЕРЕНОСА СТРОК 🔥 */
         white-space: nowrap !important;
      }

      table { 
        page-break-inside: auto; 
        width: 100% !important; 
        border-collapse: collapse !important; 
        margin-bottom: 0 !important;
        height: auto !important;
      }
      
      tr { height: auto !important; }

      th { 
        padding: 2px 5px !important; 
        border-bottom: 1px solid #000 !important; 
        font-size: 12px !important;
        font-weight: bold !important; 
        text-align: left !important; 
        height: auto !important;
      }
      
      td { 
        border-bottom: none !important; 
        padding: 0px 5px !important;
        font-size: 12px !important;
        line-height: 1.1 !important;
        vertical-align: middle !important; 
        height: 16px !important;
      }

      th.text-right-print, td.text-right-print, 
      input[type="number"], input.qty-input, input.price-input { 
         text-align: right !important; 
      }
      
      input { 
        border: none !important; 
        background: transparent !important; 
        width: 100% !important; 
        font-size: 12px !important;
        font-family: inherit !important; 
        padding: 0 !important;
        margin: 0 !important;
        height: auto !important;
        line-height: 1.1 !important;
      }
      
      .note-icon { display: none !important; }
      
      /* === НАСТРОЙКИ КОММЕНТАРИЕВ (ПРИМЕЧАНИЙ К КАТЕГОРИЯМ) === */
      .cat-note-input { 
         text-align: left !important; 
         font-style: normal !important;     
         color: #000000 !important;        
         font-weight: 700 !important;      
         font-size: 13px !important;        
         border: none !important;           
         background-color: transparent !important; 
         padding: 0 !important;             
         border-radius: 0 !important;
         margin-left: 15px !important;      
         height: auto !important; 
         flex: 1 !important;                
      }      
      .cat-note-input:placeholder-shown { display: none !important; }

      .summary-box {
         background-color: white !important;
         border: 1px solid #cbd5e1 !important;
         border-radius: 12px !important;
         width: 300px !important; 
         float: right !important; 
         margin-top: 10px !important;
         padding: 10px !important;
         page-break-inside: avoid;
         text-align: right !important;
         height: auto !important;
      }
      .summary-box div { height: auto !important; visibility: visible !important; }
      
      .text-green-print { color: #16a34a !important; }
      .text-red-print { color: #dc2626 !important; }
      .text-muted-print { color: #64748b !important; }

      .rounded-table-container { border: none !important; border-radius: 0 !important; overflow: visible !important; width: 100% !important; height: auto !important; }

      /* === ЛОГИКА ДЛЯ РЕЖИМА КУХНИ === */
      .kitchen-mode .print-content-wrapper {
         width: 75% !important;      /* 3/4 ширины для контента */
         margin-right: 25% !important; /* Оставляем место справа */
         margin-left: 0 !important;    /* Прижимаем влево */
         height: auto !important;
         border-right: 2px solid #000 !important; /* Черта, отделяющая заметки */
         padding-right: 15px !important;
      }

      .kitchen-mode .price-col { display: none !important; }
      .kitchen-mode .summary-section { display: none !important; }
      
      .kitchen-mode th.col-name { width: 70% !important; }
      .kitchen-mode th.col-weight { width: 20% !important; }
      .kitchen-mode th.col-qty { width: 10% !important; }
    }
  `}</style>
);

export default PrintStyles;